import React, { createContext, useContext } from 'react'

export interface UploadContextValue {
  fileReferences: React.MutableRefObject<Map<string, File>>
  activeUploads: React.MutableRefObject<Map<string, XMLHttpRequest>>
  registerFile: (fileId: string, file: File) => void
  registerUpload: (fileId: string, xhr: XMLHttpRequest) => void
  unregisterUpload: (fileId: string) => void
  clearFileReferences: () => void
  getFile: (fileId: string) => File | undefined
}

export const UploadContext = createContext<UploadContextValue | undefined>(
  undefined
)

/**
 * Hook to access upload context
 * @throws Error if used outside UploadProvider
 */
export const useUploadContext = (): UploadContextValue => {
  const context = useContext(UploadContext)
  if (!context) {
    throw new Error('useUploadContext must be used within UploadProvider')
  }
  return context
}
